import React from 'react';

const MonAbonnementBpiLogo = ({ className }) => {
	return (
		<svg
			className={className}
			width='114'
			height='113'
			viewBox='0 0 114 113'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<rect x='0.5' width='113' height='113' fill='#FFCD00' />
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M38.7403 69C37.42 69 36.3501 67.891 36.3501 66.5238C36.3501 65.1565 37.42 64.0481 38.7403 64.0481C40.0623 64.0481 41.1311 65.1565 41.1311 66.5238C41.1311 67.891 40.0623 69 38.7403 69Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M40.601 50.4915L40.5955 61.7155H36.8806L36.8828 50.4915H40.601Z'
				fill='#5E514D'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M35.2606 56.2104C35.2606 56.8875 35.2606 58.2638 34.6177 59.4711C33.9797 60.6705 32.6993 61.7151 30.1117 61.7151H28.927L28.9281 66.4516H25.1924V50.4915L30.4479 50.491C34.7178 50.491 35.2606 54.43 35.2606 56.2104ZM28.927 52.0091V60.1675L29.2332 60.1664C30.9373 60.1664 31.4873 58.6589 31.4873 56.2081C31.4873 53.6443 30.9417 52.0103 29.2873 52.0103L28.927 52.0091Z'
				fill='#5E514D'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M78.0196 61.7155H74.2839L74.2762 54.9538C74.2762 52.2894 73.2976 52.1486 71.9374 52.1418H71.6744L71.6766 61.7155H67.9551L67.9524 50.4388C68.2547 50.4592 69.2612 50.4925 72.6175 50.4925C78.0021 50.4925 78.0163 53.0739 78.0174 55.1742L78.0196 61.7155Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M84.7233 51.6331C83.5697 51.6331 83.0246 53.7504 83.3718 56.8766C83.7944 60.6839 87.0812 60.6709 89.3063 59.7083L89.3036 61.5871C87.9368 61.9731 86.821 62.0698 85.8539 62.0698C80.243 62.0698 79.6738 57.2999 79.6738 55.8744C79.6738 53.4536 80.5043 50.1058 84.9512 50.1058C87.898 50.1058 89.5808 52.0897 89.6087 54.7474L86.0616 54.7468C86.0529 53.0857 85.715 51.6331 84.7233 51.6331Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M100.378 56.0224H93.9616L93.9649 56.0925C94.1923 60.7804 97.5694 60.6826 99.9498 59.7059L99.9487 61.5875C98.583 61.973 97.6355 62.0685 96.5793 62.0685C91.1258 62.0685 90.314 57.882 90.314 55.7392C90.314 53.2636 91.3576 50.1006 95.5236 50.104C98.5988 50.1063 100.378 52.1105 100.378 54.8954V56.0224ZM96.6306 54.3618V54.1244C96.582 52.9623 96.3529 51.6335 95.3907 51.6335C94.4591 51.6335 94.1442 52.7475 94.0124 54.2889L94.0059 54.3618H96.6306Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M55.8526 51.7617C54.9768 51.8024 53.633 52.124 53.6302 54.2424L53.6242 61.7151H49.9082L49.912 54.1203C49.9153 51.8374 51.9365 50.1044 55.0965 50.1039H55.8521L55.8526 51.7617Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M65.7157 61.715L59.7199 61.7139C57.5106 61.7116 55.9186 60.783 55.9219 58.2502C55.9263 56.19 57.0793 55.1998 58.4089 54.7199C59.0753 54.4791 59.7855 54.3672 60.4164 54.3158C61.0473 54.2638 61.5951 54.2728 61.9368 54.2717H62.0008V53.9133C62.0035 51.2636 59.446 51.5479 57.9988 51.9831C57.7249 52.069 57.4745 52.1623 57.2646 52.2538L57.2662 50.5203C58.5423 50.2095 59.4132 50.1038 60.7674 50.1038C63.9739 50.1038 65.7168 51.6598 65.7168 54.2598L65.7157 61.715ZM62.0128 60.1318L61.9991 55.7113L61.9291 55.7181C61.0079 55.8023 59.663 56.2307 59.6614 58.1462C59.6597 59.9402 60.5066 60.0951 61.3092 60.1301L62.0128 60.1318Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M13.5 61.715V45.755H17.2351V50.4915H18.4188C21.0069 50.4915 22.2862 51.5355 22.9259 52.736C23.5683 53.9427 23.5683 55.319 23.5683 55.9956C23.5683 57.776 23.0248 61.7156 18.755 61.7156L13.5 61.715ZM19.7954 55.9685C19.7954 53.5177 19.2454 52.0103 17.5391 52.0103L17.2351 52.0091V60.1675L17.5938 60.1664C19.2481 60.1664 19.7954 58.5323 19.7954 55.9685Z'
				fill='#5E514D'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M49.8546 45.755L49.8535 47.3823C49.4872 47.3823 49.1188 47.3823 48.7689 47.4111C48.3971 47.441 48.0439 47.5049 47.7372 47.6366C47.1123 47.9045 46.6963 48.4528 46.6952 49.5335V50.4915H49.3156L49.3139 52.1403H46.687L46.6892 61.7156H42.9753V50.4186C42.9753 46.245 45.745 45.755 49.0996 45.755H49.8546Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M38.7403 48.1718C37.42 48.1718 36.3501 47.0639 36.3501 45.6967C36.3501 44.3294 37.42 43.2205 38.7403 43.2205C40.0623 43.2205 41.1311 44.3294 41.1311 45.6967C41.1311 47.0639 40.0623 48.1718 38.7403 48.1718Z'
				fill='#5E514D'
			/>
		</svg>
	);
};

export default MonAbonnementBpiLogo;



// WEBPACK FOOTER //
// ./src/opencell/svgComponents/MonAbonnementBpiLogo.jsx